export default __webpack_public_path__ + "static/media/march-svgrepo-com.06effa44.svg";